import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { Alert } from 'src/components/alert';
import { SmallContainer } from 'src/components/container';
import { ImagesSlider } from 'src/components/images-slider';
import { NavigationButton } from 'src/components/navigation-button';
import { breakpointTablet } from 'src/styles/breakpoints';
import { colorMediumGrey } from 'src/styles/colors';
import { spacing1, spacing10, spacing2, spacing3, spacing4, spacing5, spacing6, spacing9 } from 'src/styles/spacing';

export const StyledContainer = styled(SmallContainer)`
  margin-top: ${spacing2};
  margin-bottom: ${spacing9};

  @media (min-width: ${breakpointTablet}) {
    margin-top: ${spacing6};
  }
`;

export const StyledImageSlider = styled(ImagesSlider)`
  margin-bottom: ${spacing4};

  @media (min-width: ${breakpointTablet}) {
    margin-bottom: ${spacing10};
  }
`;

export const StyledTitle = styled(Typography)`
  margin: ${spacing4} 0;

  @media (min-width: ${breakpointTablet}) {
    margin: ${spacing5} 0;
  }
`;

export const StyledMonthlyCost = styled(Typography)`
  padding-top: ${spacing4};
  padding-bottom: ${spacing1};
  border-top: 1px solid ${colorMediumGrey};
  margin-top: ${spacing4};

  @media (min-width: ${breakpointTablet}) {
    margin-top: ${spacing6};
  }
`;

export const StyledTotalPrice = styled(Typography)`
  margin-left: ${spacing1};
`;

export const StyledNavigationButton = styled(NavigationButton)`
  margin: ${spacing4} 0;

  @media (min-width: ${breakpointTablet}) {
    margin-top: ${spacing5};
    margin-bottom: ${spacing4};
  }
`;

export const StyledFootNote = styled(Typography)`
  padding-top: ${spacing2};
`;

export const StyledBuyOnlyOnceAlert = styled(Alert)`
  margin-top: ${spacing3};

  @media (min-width: ${breakpointTablet}) {
    margin-top: ${spacing4};
  }
`;
